import PropTypes from 'prop-types';
import { useRef } from 'react';

import Block from 'shopper/components/Block';
import Button from 'shopper/components/Button';
import { Dropdown } from 'shopper/components/Dropdown';
import Icon from 'shopper/components/Icon';

import useToggle from 'hooks/useToggle';

import { sendEvent } from 'lib/gtag';
import { getOfferPageEventCategory } from 'lib/offer';

import ReportDropdownOptions from './ReportDropdownOptions';

import ACTIONS from 'constants/action';

const ReportDropdown = ({ offerId, offerStatusName }) => {
  const reportButtonElem = useRef();
  const [isOpen, setOpen] = useToggle();

  const onCloseDropdown = () => {
    setOpen(false);
  };

  return (
    <Block
      height="fit-content"
      position="relative"
      display={['none', null, 'block']}
    >
      <Button
        type="subtle"
        size="size3"
        iconLeft={<Icon name="bullhorn" />}
        ref={reportButtonElem}
        onClick={() => {
          sendEvent({
            action: 'report_offer',
            category: getOfferPageEventCategory(offerStatusName),
          });
          setOpen((prev) => !prev);
        }}
      >
        {ACTIONS.REPORT}
      </Button>
      <Dropdown
        openerRef={reportButtonElem}
        open={isOpen}
        onClickOutside={() => setOpen(false)}
      >
        <ReportDropdownOptions
          offerId={offerId}
          offerStatusName={offerStatusName}
          onCloseDropdown={onCloseDropdown}
        />
      </Dropdown>
    </Block>
  );
};

ReportDropdown.propTypes = {
  offerId: PropTypes.number.isRequired,
  offerStatusName: PropTypes.string.isRequired,
};

export default ReportDropdown;
